import React, { ChangeEvent, useState } from 'react'
import axios from 'axios'
import { notify } from 'components/toastify'
import { STATUS } from 'constants/messages'
import axiosClient from 'network/axiosClient'
import ReactLoading from 'react-loading'
import ButtonBase from 'components/partials/button'

interface Props {
  handleGetData: (take: number, skip: number) => Promise<void>
}

const UploadFile: React.FC<Props> = ({ handleGetData }) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const [error, setError] = useState<string>('')
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    setIsLoading(true)
    event.preventDefault()
    const form = event.currentTarget
    const data = new FormData(form)
    const file = data.get('file') as File

    const presignedURLResponse = await axiosClient.get('/bondData/presigned', {
      params: { fileName: file.name },
    })

    const presignedUrl = presignedURLResponse.data.url
    const newFileName = presignedURLResponse.data.fileName ?? file.name

    const response = await axios.put(presignedUrl, file, {
      headers: { 'Content-Type': 'application/octet-stream' },
    })

    if (response.status === 200) {
      notify('Upload file successfully!', STATUS.SUCCESS)
      await axiosClient.post('/bondData/store', {
        fileName: newFileName,
      })

      await handleGetData(20, 0)
    }

    setIsLoading(false)
  }

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]

    if (file && file.type === 'application/json') {
      setSelectedFile(file)
      setError('')
    } else {
      setSelectedFile(null)
      setError('Only .json files are allowed')
    }
  }

  return isLoading ? (
    <div className="flex justify-center p-5">
      <ReactLoading type="spin" color="#A989D8" height={30} width={30} />
    </div>
  ) : (
    <div className="flex items-center justify-end pb-5">
      <form className="flex items-center" onSubmit={handleSubmit}>
        <input type="file" name="file" accept=".json" onChange={handleFileChange} />
        {error && <p className="text-red-500 px-2">{error}</p>}
        <ButtonBase
          className=""
          bgHover="Upload file button"
          disabled={!selectedFile}
          bgDisabled="bg-violet-600"
          type="submit"
        >
          Upload
        </ButtonBase>
      </form>
    </div>
  )
}

export default UploadFile
